import { Col, Divider, Row } from 'antd';
import React, { FC } from 'react';
import { nullSafeGet, nullSafeGetOrElse } from '../../utils/DataAccessUtils';
import {
	BLACKS_AND_WHITES,
	getTimeDurationFromSeconds,
	STOPLIGHT_COLORS,
} from '../../utils/DataFormatterUtils';
import { CustomCurrencyDisplay } from '../custom_currency_display/CustomCurrencyDisplay';
import { DetailsDisplay } from '../details_display/DetailsDisplay';

require('./QuotesDetailDetailsPage.less');

const SimpleLineItemsDisplay = ({ quote, lineItemFieldName, currency }) => {
	return nullSafeGetOrElse(lineItemFieldName, quote, []).map((li, idx) => (
		<div
			key={`${lineItemFieldName}-${idx}`}
			className="sectionHeaderWrapper2"
			style={{
				marginBottom: idx === nullSafeGetOrElse(lineItemFieldName, quote, []).length - 1 ? 16 : 8,
			}}
		>
			<span className="lineItemDetailText">{li.description}</span>
			<span className="lineItemDetailText">{currency.format(parseFloat(li.amount))}</span>
		</div>
	));
};

const QuotesDetailDisplay: FC<any> = ({
	quote = {},
	lastQuote = {},
	displayComparison = false,
	currency,
}): React.ReactElement => {
	return (
		<>
			<Divider />
			<DetailsDisplay
				title={'Incurred Costs'}
				fieldName={'incurredCostTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="incurredCostLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Labor'}
				fieldName={'laborTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('laborLineItems', quote, []).map((lli, idx) => (
				<div
					key={`lli-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{lli.numberOfTech} {lli.roleType} * {getTimeDurationFromSeconds(lli.seconds)} @{' '}
						{currency.format(parseFloat(lli.hourlyRate))} / hour
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(lli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Materials'}
				fieldName={'materialTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('materialLineItems', quote, []).map((mli, idx) => (
				<div
					key={`mali-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom:
							idx === nullSafeGetOrElse('laborLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">
						{mli.quantity} {mli.unitType} of {mli.description}
						{mli.partNumber ? ` (${mli.partNumber})` : null} @{' '}
						{currency.format(parseFloat(mli.unitPrice))} / {mli.unitType}
					</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Travel'}
				fieldName={'travelTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="travelLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Freight'}
				fieldName={'freightTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<SimpleLineItemsDisplay
				quote={quote}
				lineItemFieldName="freightLineItems"
				currency={currency}
			/>
			<Divider />
			<DetailsDisplay
				title={'Miscellaneous'}
				fieldName={'miscTotalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			{nullSafeGetOrElse('miscLineItems', quote, []).map((mli, idx) => (
				<div
					key={`mili-${idx}`}
					className="sectionHeaderWrapper2"
					style={{
						marginBottom: idx === nullSafeGetOrElse('miscLineItems', quote, []).length - 1 ? 16 : 8,
					}}
				>
					<span className="lineItemDetailText">{mli.description}</span>
					<span className="lineItemDetailText">{currency.format(parseFloat(mli.amount))}</span>
				</div>
			))}
			<Divider />
			<DetailsDisplay
				title={'Total Before Tax'}
				fieldName={'totalBeforeTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<Divider />
			<DetailsDisplay
				title={'Tax'}
				fieldName={'tax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
			<Divider />
			<DetailsDisplay
				title={'Total After Tax'}
				fieldName={'totalAfterTax'}
				record={quote}
				lastRecord={lastQuote}
				currency={currency}
				displayComparison={displayComparison}
			/>
		</>
	);
};

export default QuotesDetailDisplay;
